/**
 * Shared board → lucide icon mapping. Replaces the emoji-as-icon tiles in the
 * Boards flyout (App.tsx) and the /boards pages with one consistent
 * monochrome line-icon set, matching the lucide sidebar (Wiz parity).
 *
 * Keyed by board display name. Use getBoardIcon(name, className).
 */
import React from 'react';
import {
  LayoutDashboard, Radio, DollarSign, Code, Target, Globe, AlertTriangle,
  User, ShieldCheck, KeyRound, Database, Boxes, Zap, Bug, Wrench, Bot,
  Brain, ShieldAlert, Siren, LayoutGrid,
} from 'lucide-react';

const BOARD_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  'Overview': LayoutDashboard,
  'Threat Intel Center': Radio,
  'Cloud Cost': DollarSign,
  'Secure Development': Code,
  'Security Score': Target,
  'Attack Surface': Globe,
  'Attack Surface Management': Globe,
  'External Exposure': AlertTriangle,
  'Identity Security': User,
  'Cloud Configuration': ShieldCheck,
  'Secure Cloud Configuration': ShieldCheck,
  'Secrets': KeyRound,
  'Secure Use of Secrets': KeyRound,
  'Data Security': Database,
  'Container & K8s': Boxes,
  'Container & Kubernetes Security': Boxes,
  'Serverless': Zap,
  'Vulnerability Mgmt': Bug,
  'Vulnerability Management': Bug,
  'Patch Management': Wrench,
  'Non-Human Identities': Bot,
  'AI Security': Brain,
  'High Profile Threats': ShieldAlert,
  'Incident Readiness': Siren,
};

export function getBoardIcon(name: string, className = 'w-4 h-4'): React.ReactNode {
  const Icon = BOARD_ICONS[name] || LayoutGrid;
  return <Icon className={className} />;
}
